import { render, staticRenderFns } from "./AddingNewChild.vue?vue&type=template&id=27a127ca&scoped=true&"
import script from "./AddingNewChild.vue?vue&type=script&lang=js&"
export * from "./AddingNewChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a127ca",
  null
  
)

export default component.exports